export const HEADER_CONFIG = {
  HEIGHT: '60px',
  BG_COLOR: 'white',
  NAVIGATION_HEIGHT: '32px',
} as const;

export const COLORS = {
  ACTIVE_BG: '#6B5FC6',
  ACTIVE_HOVER: '#6347CC',
  ACTIVE_PRESSED: '#5639B5',
  INACTIVE_TEXT: 'gray.700',
  ACTIVE_TEXT: '#FFFFFF',
} as const;

export const MENU_ITEMS = {
  blocks: ['All Blocks', 'Financial Blocks', 'Custom Blocks'],
  dimensions: ['Time Dimensions', 'Product Dimensions', 'Location Dimensions'],
  import: ['Import CSV', 'Import Excel', 'Connect Database'],
} as const;

export const BUTTON_STYLES = {
  fontWeight: 900,
  fontSize: '16px',
  lineHeight: '100%',
  letterSpacing: '0%',
  textAlign: 'center' as const,
  // borderRadius: '12px',
  width: 'auto',
} as const;
